import React from 'react'

import { Controller, SubmitHandler, useForm } from 'react-hook-form'

import { CustomButton } from '@components/CustomButton'
import { FormSelect } from '@components/Form/FormSelect'
import { useEditProfile, useFindProfile } from '@hooks/profile'
import { useUtils } from '@hooks/utils'
import { queryClient } from '@services/queryClient'

import { FormContainer } from './styles'

type TSiteIdentifier = {
  site: number
}

export function SiteSelectionForm() {
  const { sortParams } = useUtils()
  const { data: rawUser } = useFindProfile()
  const user = rawUser ?? ({} as NonNullable<typeof rawUser>)

  const { mutateAsync: putProfile } = useEditProfile()
  const { isFetching } = useFindProfile()

  const userSites = user?.sites
    .map((site) => {
      return { label: site.name, value: site.id }
    })
    .sort((a, b) => sortParams(a.label, b.label))

  const {
    control,
    handleSubmit,
    formState: { isDirty },
  } = useForm({
    defaultValues: {
      site: user.selectedSite.id,
    },
  })

  const handleSave: SubmitHandler<TSiteIdentifier> = (
    value: TSiteIdentifier,
  ) => {
    putProfile(Number(value.site))
    queryClient.refetchQueries()
  }

  return (
    <>
      {user?.isGlobalAdmin && (
        <FormContainer>
          <Controller
            control={control}
            name="site"
            render={({
              field: { onChange, value },
              fieldState: { error },
              formState: { defaultValues },
            }) => (
              <FormSelect
                defaultValue={defaultValues?.site?.toString()}
                items={userSites}
                errorMessage={error?.message}
                onValueChange={(value) => onChange(Number(value))}
                selectedValue={value?.toString()}
              />
            )}
          />
          <CustomButton
            isDisabled={!isDirty || isFetching}
            onPress={handleSubmit(handleSave)}
            isLoading={isFetching}
          >
            Save
          </CustomButton>
        </FormContainer>
      )}
    </>
  )
}
